
import Float from './float.js';
export default {
  mixins: [Float]
}
